import React from 'react'

function MegaPhone() {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity={0.48}>
        <path
          d="M1 8.842s0-3.158 5.053-3.79c3.213-.401 8.079-3.065 10.736-4.42C18.029 0 19 0 19 0s-3.474 1.263-3.474 10.105S19 20 19 20s-1.384 0-2.21-.421c-2.658-1.355-7.524-4.02-10.737-4.421C1 14.526 1 11.368 1 11.368V8.842z"
          fill="#fff"
        />
        <path
          d="M22.368 10c0 2.702-.439 5.118-1.126 6.837-.344.86-.739 1.515-1.144 1.943-.404.427-.775.588-1.098.588-.323 0-.694-.16-1.098-.588-.405-.428-.8-1.083-1.144-1.944-.687-1.718-1.126-4.134-1.126-6.836s.439-5.118 1.126-6.837c.344-.86.739-1.514 1.144-1.943.404-.428.775-.588 1.098-.588.323 0 .694.16 1.098.588.405.429.8 1.083 1.144 1.944.687 1.718 1.126 4.134 1.126 6.836z"
          stroke="#fff"
          strokeWidth={1.263}
        />
        <path
          d="M14.632 10c0 1.005.255 1.885.636 2.494.386.617.838.874 1.232.874s.846-.257 1.232-.874c.38-.609.636-1.489.636-2.494 0-1.005-.255-1.885-.636-2.494-.386-.617-.838-.874-1.232-.874s-.846.257-1.232.874c-.38.609-.636 1.489-.636 2.494z"
          fill="#fff"
          stroke="#fff"
          strokeWidth={1.263}
        />
        <path d="M7.5 14.5h2v8a1 1 0 11-2 0v-8z" stroke="#fff" />
        <path fill="#fff" d="M8 20h1v1H8z" />
      </g>
    </svg>
  )
}

export default React.memo(MegaPhone)
